import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Reframe } from './components/sections/Reframe';
import { DrainList } from './components/sections/DrainList';
import { FourAreas } from './components/sections/FourAreas';
import { WhatYoullLearn } from './components/sections/WhatYoullLearn';
import { EbookSection } from './components/sections/EbookSection';
import { ForYouSection } from './components/sections/ForYouSection';
import { PullQuote } from './components/sections/PullQuote';
import { Testimonials } from './components/sections/Testimonials';
import { AboutFreddy } from './components/sections/AboutFreddy';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { WhatsAppButton } from './components/ui/WhatsAppButton';
export function App() {
  return <div className="min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoints data-id="element-3" />
        <Reframe data-id="element-4" />
        <DrainList data-id="element-5" />
        <FourAreas data-id="element-6" />
        <WhatYoullLearn data-id="element-7" />
        <EbookSection data-id="element-8" />
        <ForYouSection data-id="element-9" />
        <PullQuote data-id="element-10" />
        <Testimonials data-id="element-11" />
        <AboutFreddy data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <WhatsAppButton data-id="element-15" />
    </div>;
}